import firebase from 'firebase/app';
import database from 'firebase/database';

const env = 'testing';

const config = {
    apiKey: "AIzaSyCN_-ERUT6qdHWsu0v_w_ib3ZXzWe_7228",
    authDomain: "va-lottery-holiday-quiz.firebaseapp.com",
    databaseURL: "https://va-lottery-holiday-quiz.firebaseio.com",
    storageBucket: "va-lottery-holiday-quiz.appspot.com",
    messagingSenderId: "477031725908"
};

firebase.initializeApp(config);

export function addChoiceToFirebase(choice, userId, sessionId, questionId, cb) {

    // add choice to firebase
    const answerData = {
        env: window.location.hostname,
        choice,
        userId,
        sessionId,
        questionId,
        createdOn: firebase.database.ServerValue.TIMESTAMP,
    }

    // add to answers collection and invoke callback on success
    firebase.database().ref().child('answers').push(answerData, function(err) {
        if (err) { console.log('error: ', err) }
        cb();
    });
}

export function addResultToFirebase(scratcher, userId, sessionId) {

    // add choice to firebase
    const data = {
        env: window.location.hostname,
        scratcher,
        userId,
        sessionId,
        createdOn: firebase.database.ServerValue.TIMESTAMP,
    }

    // add to answers collection and invoke callback on success
    firebase.database().ref().child('results').push(data, function(err) {
        if (err) { console.log('error: ', err) }
    });
}


/** WEBPACK FOOTER **
 ** ./src/firebase.js
 **/